export default "__VITE_ASSET__c885cb4c__"